import { render, staticRenderFns } from "./DefaultDetail.vue?vue&type=template&id=53721103&scoped=true"
import script from "./DefaultDetail.vue?vue&type=script&lang=js"
export * from "./DefaultDetail.vue?vue&type=script&lang=js"
import style0 from "./DefaultDetail.vue?vue&type=style&index=0&id=53721103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53721103",
  null
  
)

export default component.exports